import "./SectionPage.scss";
import { ContentAreaType } from "/Models/Generated/ContentAreaType";
import { ContentArea, HeroWithImageThematic } from "/App.Components";
import { SectionPageProps } from "/Models/Generated/SectionPageProps";
import { ContentAreaItemMargin } from "../../Shared/ContentAreaItem/ContentAreaItem";

const SectionPage = ({ pageHeader, contentArea }: SectionPageProps) => (
  <div className="section-page-norad">
    {pageHeader && <HeroWithImageThematic {...pageHeader} />}
    <div className="section-page-norad__main-content">
      <ContentArea
        {...contentArea}
        contentAreaType={ContentAreaType.FullWidth}
        margin={ContentAreaItemMargin.Huge}
      />
    </div>
  </div>
);

export default SectionPage;
